import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Container, Spinner, TabContent, TabPane,NavLink, NavItem,Nav, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import SweetAlert from "react-bootstrap-sweetalert";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"
import { Link } from "react-router-dom"


class EditCountry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      country:false,
      activeTab: "1",
      states: [],
      breadcrumbItems: [
        { title: "countries", link: "/manage-countries" },
        { title: "Edit country", link: "#" },
      ],
    };
    toastr.options = {
        positionClass: "toast-top-right",
        closeButton: "true",
        progressBar: "true",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        showDuration: 300,
        hideDuration: 1000,
        timeOut: 5000,
        extendedTimeOut: 1000
    }
	

    this.handleSubmit = this.handleSubmit.bind(this);   
    this.toggle = this.toggle.bind(this); 

    } 

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/manage-countries')
  }
  async componentDidMount(){
      await this.loadcountry()
      await this.loadStatesData()
  }

  loadcountry(){
    const id =this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        };
        fetch(`${BaseUrl}/api/locations/location/countries/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.props.history.push(`/manage-countries`)
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.setState({country:data})
                          }
                      )
                  }    
              }
          )

  }
  
  async loadStatesData(){
    const id =this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/states/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState({ states: data  })
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }
  
  handleSubmit(e, values) {
    this.setState({ loading: true })
    const {country} = this.state
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/locations/location/countries/${country.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ loading: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          toastr.success(`Country Updated Successfully`, "") 
                          this.setState({ loading: false })
                          }
                      )
                  }    
              }
          )

  }

  handlecountryClicks = id => {   

    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/locations/location/states/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadcountry()
                    this.loadStatesData()
                    this.setState({
                      brand_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "State has been deleted."
                      })
                         
                  }
              }
          )

  }

  
  

  render() {
      const {country, states} = this.state
      const { SearchBar } = Search

        //pagination customization
        let total_size = states.length 
        const pageOptions = {
        sizePerPage: 10,
        totalSize: total_size, // replace later with size(Order),
        custom: true,
        }

        const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
        }];

        //Columns
        const statesColumns = [
        {
            dataField: "id",
            text: "id",
            hidden: true,
            sort: true,
        },
        {
            dataField: "name",
            text: "Name",
            sort: true,
            headerStyle: {  width:'90%' },
        },
        {
            dataField: "action",
            isDummyField: true,
            text: "Action",
            headerStyle: {  width:'20%' },
            formatter: (cellContent, row) => (
            <React.Fragment>
                <Link to="#" onClick={() => this.props.history.push(`/state/${row.id}`) } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                <Link to="#" onClick={() => this.setState({ alert_confirm: true, country_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                </React.Fragment>
            ),
        },
        ]
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Edit Country" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
                <Col xl={12}>    
                    <Card>
                        <CardBody>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: this.state.activeTab === "1"
                                        })}
                                        onClick={() => {
                                            this.toggle("1");
                                        }}
                                    >
                                        Edit
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: this.state.activeTab === "2"
                                        })}
                                        onClick={() => {
                                            this.toggle("2");
                                        }}
                                    >
                                        States
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1" className="p-3">
                                    <Row className="mt-3">
                                        <Col sm="12">
                                            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
                                                <Row>
                                                    <Col xl="6">
                                                    {/* <Card>
                                                        <CardBody>  */}
                                                        <h4 className="card-title">Edit country</h4>
                                                            <Row>
                                                            <Col md="6">
                                                                <div className="mb-3">
                                                                <Label className="form-label " htmlFor="name">country Name</Label>
                                                                <AvField
                                                                    name="name"
                                                                    placeholder="country Name"
                                                                    type="text"
                                                                    value={country?country.name:""}
                                                                    errorMessage="Enter country Name"
                                                                    className="form-control"
                                                                    validate={{ required: { value: true } }}
                                                                    id="name"
                                                                    
                                                                />
                                                                </div>
                                                            </Col> 
                                                            </Row>
                                                                            
                                                            <FormGroup className="mb-0">
                                                            {this.state.loading?(
                                                                <Spinner className="me-2 mt-2" color="primary" />
                                                            ):(
                                                                <div>
                                                            
                                                            <Button type="submit" color="primary" className="me-1">
                                                                Submit
                                                            </Button>{" "}
                                                            <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                                                                Cancel
                                                            </Button>
                                                            </div>
                                                            )}
                                                        </FormGroup>      
                                                    </Col>
                                                </Row>
                                            </AvForm>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2" className="p-3">
                                <Row>
                                    <Col xs="12">
                                        <Card>
                                        <CardBody>
                                            <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            data={states}
                                            >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                keyField="id"
                                                data={states}
                                                columns={statesColumns}
                                                bootstrap4
                                                search
                                                >
                                                
                                                {toolkitProps => (
                                                    <React.Fragment>
                                                    
                                                    <Row className="mb-2">
                                                        <Col sm="4">
                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                            <div className="position-relative">
                                                            <SearchBar
                                                                {...toolkitProps.searchProps}
                                                            />
                                                            <i className="bx bx-search-alt search-icon" />
                                                            </div>
                                                        </div>
                                                        </Col>
                                                        <Col sm="8">
                                                        <div className="text-sm-end">
                                                            <Button
                                                            type="button"
                                                            color="success"
                                                            className="btn-rounded mb-2 me-2"
                                                            onClick={() => this.props.history.push(`/new-state/${this.props.match.params.id}`)}
                                                            >
                                                            <i className="mdi mdi-plus me-1" />{" "}
                                                            Add New State
                                                            </Button>
                                                        </div>
                                                        </Col>
                                                    </Row>
                                                    <div className="table-responsive">

                                                        <BootstrapTable
                                                        {...toolkitProps.baseProps}
                                                        {...paginationTableProps}
                                                        responsive
                                                        bordered={false}
                                                        striped={false}
                                                        defaultSorted={defaultSorted}
                                                        headerWrapperClasses={"table-light"}
                                                        />
                                                        
                                                    </div>
                                                    <div className="pagination pagination-rounded justify-content-end mb-2">
                                                        <PaginationListStandalone
                                                        {...paginationProps}
                                                        />
                                                    </div>
                                                    {this.state.alert_confirm ? (
                                                                            <SweetAlert
                                                                            title="Are you sure?"
                                                                            warning
                                                                            showCancel
                                                                            confirmBtnBsStyle="success"
                                                                            cancelBtnBsStyle="danger"
                                                                            onConfirm={() => this.handlecountryClicks(this.state.country_id)}
                                                                            onCancel={() =>
                                                                                this.setState({
                                                                                    alert_confirm: false,
                                                                                    country_id:"",

                                                                                })
                                                                            }
                                                                            >
                                                                            You won't be able to revert this!
                                                                            </SweetAlert>
                                                                        ) : null}

                                                                    {this.state.success_confirm ? (
                                                                    <SweetAlert
                                                                    success
                                                                    title={this.state.dynamic_title}
                                                                    confirmBtnBsStyle="success"
                                                                    cancelBtnBsStyle="danger"
                                                                    onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                                                    >
                                                                        {this.state.dynamic_description}
                                                                    </SweetAlert>
                                                                )
                                                                : null
                                                            }
                                                    </React.Fragment>
                                                )}
                                                </ToolkitProvider>
                                            )}
                                            </PaginationProvider>
                                        </CardBody>
                                        </Card>
                                    </Col>
                                    </Row>
                                </TabPane>
                                
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default EditCountry;



    